/**
=========================================================
* Material Dashboard 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Alert, Snackbar } from "@mui/material";
import useAuthorizedRequest from "components/AuthorizedRequest";

function CategoryAdd() {
  // const [status, setStatus] = useState(1);
  // const [categoryName, setCategoryName] = useState({
  //   category_name: "",
  // });

  const [categoryData, setCategoryData] = useState({
    category_name: "",
    status: "active",
  });
  const [snackProps, setSnackProps] = useState({
    message: "",
    severity: "info",
    isOpen: false,
  });
  const authorizedRequestInstance = useAuthorizedRequest();

  // const handleStatusChange = (event) => {
  //   setStatus(event.target.value);
  // };

  const handleSubmitCategory = () => {
    authorizedRequestInstance
      .post("/category", categoryData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then(() => {
        setSnackProps({
          isOpen: true,
          message: "New Category Saved",
          severity: "success",
        });
        setCategoryData({
          category_name: "",
          status: 1,
        });
      })
      .catch((err) => {
        setSnackProps({
          isOpen: true,
          message: `${err.response.data.message}`,
          severity: "error",
        });
      });
  };

  const handleSnackClose = () => {
    setSnackProps({ ...snackProps, isOpen: false });
  };

  // console.log(categoryData);

  return (
    <DashboardLayout>
      <div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackProps.isOpen}
          onClose={handleSnackClose}
          autoHideDuration={6000}
        >
          <Alert onClose={handleSnackClose} severity={snackProps.severity} sx={{ width: "100%" }}>
            {snackProps.message}
          </Alert>
        </Snackbar>
      </div>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Card>
              <MDBox pt={4} pb={3} px={3}>
                <MDBox
                  component="form"
                  role="form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmitCategory();
                  }}
                >
                  <MDBox mb={2}>
                    <MDTypography variant="text">Category Name</MDTypography>
                    <MDInput
                      value={categoryData.category_name}
                      onChange={(e) =>
                        setCategoryData({
                          category_name: e.target.value,
                          status: categoryData.status,
                        })
                      }
                      type="input"
                      fullWidth
                      placeholder="Product Name"
                    />
                  </MDBox>
                  {/* <MDBox mb={2}>
                    <MDTypography variant="text">Status</MDTypography>
                    <Select
                      labelId="status"
                      id="status"
                      value={categoryData.status}
                      label="status"
                      variant="standard"
                      defaultValue=""
                      onChange={(e) =>
                        setCategoryData({
                          category_name: categoryData.category_name,
                          status: e.target.value,
                        })
                      }
                      fullWidth
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>Inactive</MenuItem>
                    </Select>
                  </MDBox> */}
                  <MDBox mt={4} mb={1}>
                    <MDButton
                      variant="gradient"
                      color="success"
                      fullWidth
                      onClick={handleSubmitCategory}
                    >
                      Save
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CategoryAdd;
